import React from 'react'

function Alert(props) { 
  const capitalize = (word)=>{
  const lower = word.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  
  const transformText = (text, caseType) => {
    switch (caseType) {
      case 'uppercase':
        return text.toUpperCase();
      case 'lowercase':
        return text.toLowerCase();
      case 'capitalize':
        return capitalize(text);
      default:
        return text;
    }
  };

  // Background and text color styles for both light and dark modes
  const alertStyle = {
    backgroundColor: '#17a2b8', // light red for alert
    color: '#ffffff', // dark red text for light mode
  };

  


  return (
   props.alert && <div className={`alert alert-${props.alert.type} alert-dismissible fade show`} role= "alert" style={alertStyle}>
      <strong>{capitalize(props.alert.type)}</strong>: {transformText(props.alert.msg, 'capitalize')}
    
  </div>
  )
}

export default Alert;


  